/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ExchangeBehavior = {
    PreserveConnection: 'preserve_connection',
    SeverConnection: 'sever_connection'
} as const;
export type ExchangeBehavior = typeof ExchangeBehavior[keyof typeof ExchangeBehavior];


export function ExchangeBehaviorFromJSON(json: any): ExchangeBehavior {
    return ExchangeBehaviorFromJSONTyped(json, false);
}

export function ExchangeBehaviorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExchangeBehavior {
    return json as ExchangeBehavior;
}

export function ExchangeBehaviorToJSON(value?: ExchangeBehavior | null): any {
    return value as any;
}

